import { FormEvent, useEffect, useState } from 'react';
import { IListItem } from '@nkr/models/index';
import { Button, Col, ControlLabel, Form, FormControl, FormGroup, Label, Modal, Radio } from 'react-bootstrap';
import usePrevious from '@nkr/services/use-previous';

interface IProps {
    show: boolean,
    ruleOutReasons: IListItem[]
    onSubmit: (isExpireRuleOut: number, isInEmr: number, disposition: number, ruleOutReasons: string) => void,
    onCancel: () => void
}

const RuleOut = (props: IProps) => {
    const [isExpireRuleOut, setIsExpireRuleOut] = useState(0);
    const [isInEmr, setIsInEmr] = useState(0);
    const [disposition, setDisposition] = useState(-1);
    const [dispositionValid, setDispositionValid] = useState(true);
    const [ruleOutReasons, setRuleOutReasons] = useState('');
    const [dirty, setDirty] = useState(false);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show) {
            setIsExpireRuleOut(0);
            setIsInEmr(0);
            setDisposition(-1);
            setDispositionValid(true);
            setRuleOutReasons('');
            setDirty(false);
        }
    }, [props.show]);

    const handleFieldChangeChange = (name: string, value: any) => {
        if (name == 'isExpireRuleOut') {
            setIsExpireRuleOut(parseInt(value));
        }

        if (name == 'isInEmr') {
            setIsInEmr(parseInt(value));
        }

        if (name == 'disposition') {
            setDisposition(parseInt(value));
        }

        if (name == 'ruleOutReasons') {
            setRuleOutReasons(value);
        }
    }

    const handleSubmit = () => {
        if (disposition > 0) {
            props.onSubmit(isExpireRuleOut, isInEmr, disposition, ruleOutReasons);
        } else {
            setDirty(true);
            setDispositionValid(false);
        }
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Rule Out</Modal.Header>
            <Modal.Body>
                <Form horizontal>
                    <FormGroup>
                        <Col xs={12} sm={5} componentClass={ControlLabel}>Expire to allow re-registration?</Col>
                        <Col xs={12} sm={7}>
                            <Radio inline name='isExpireRuleOut' value={1} checked={isExpireRuleOut == 1} onClick={() => handleFieldChangeChange('isExpireRuleOut', 1)}>Yes</Radio>
                            <Radio inline name='isExpireRuleOut' value={0} checked={isExpireRuleOut == 0} onClick={() => handleFieldChangeChange('isExpireRuleOut', 0)}>No</Radio>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} sm={5} componentClass={ControlLabel}>Is In EMR?</Col>
                        <Col xs={12} sm={7}>
                            <Radio inline name='isInEmr' value={1} checked={isInEmr == 1} onClick={() => handleFieldChangeChange('isInEmr', 1)}>Yes</Radio>
                            <Radio inline name='isInEmr' value={0} checked={isInEmr == 0} onClick={() => handleFieldChangeChange('isInEmr', 0)}>No</Radio>
                        </Col>
                    </FormGroup>

                    <FormGroup validationState={dirty && !dispositionValid ? 'error' : null}>
                        <Col xs={12} sm={5} componentClass={ControlLabel}>Rule-Out Disposition</Col>
                        <Col xs={12} sm={7}>
                            <FormControl
                                componentClass='select'
                                value={disposition}
                                onChange={(e: FormEvent<FormControl & HTMLSelectElement>) => handleFieldChangeChange('disposition', e.currentTarget.value)}
                            >
                                <option value={-1}>- Select -</option>
                                {props.ruleOutReasons.map(item =>
                                    <option key={'rule-' + item.id} value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                            <Label bsStyle='warning' style={{ color: '#333', float: 'right' }}>this will override any existing disposition</Label>
                        </Col>
                    </FormGroup>

                    <FormGroup>
                        <Col xs={12} sm={5} componentClass={ControlLabel}>Additional details of Rule Out</Col>
                        <Col xs={12} sm={7}>
                            <FormControl
                                componentClass='textarea'
                                name='ruleOutReasons'
                                style={{ resize: 'none' }}
                                value={ruleOutReasons}
                                onChange={(e: FormEvent<FormControl & HTMLInputElement>) => handleFieldChangeChange('ruleOutReasons', e.currentTarget.value)}
                            />
                        </Col>
                    </FormGroup>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleSubmit}>Rule Out</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RuleOut;